










import { defineComponent } from "@vue/composition-api";
import { ContentFeedType } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import CheckAuthorities from "@/components/CheckAuthorities";

export default defineComponent({
  name: "CreatePostButton",
  components: { CheckAuthorities, BaseButton, BaseIcon },
  props: {
    userId: { type: String, required: true },
    type: { type: String as () => ContentFeedType, default: undefined },
  },
  setup() {
    const { authUser } = useAuthUser();
    return {
      authUser,
    };
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    requiredAuthorities(): string[] {
      const isAuthor = (this.authUser && this.authUser.id === this.userId) || false;
      return isAuthor ? ["createMyContentSet"] : ["createAnyContentSet"];
    },
  },
  methods: {
    onClick() {
      emitter.emit(EVENTS.SHOW_CREATE_POST, { userId: this.userId, type: this.type });
    },
  },
});
